import { render, staticRenderFns } from "./TradeProductDetails.vue?vue&type=template&id=b859052e&"
import script from "./TradeProductDetails.vue?vue&type=script&lang=js&"
export * from "./TradeProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./TradeProductDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports